/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'setting': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 20',
    data: '<path pid="0" class="st0" d="M18.3 11.2c.1-.4.1-.9.1-1.3s0-.9-.1-1.3L19 8c.6-.5.7-1.4.2-2.2l-.7-1.2c-.4-.8-1.3-1.1-2-.9l-.9.3c-.6-.5-1.4-1-2.3-1.3l-.2-.9C13 1 12.2.5 11.3.5H9.8c-1 0-1.7.5-1.9 1.3l-.2.9c-.8.3-1.6.7-2.3 1.3l-.9-.3c-.7-.3-1.5.1-2 .9l-.7 1.2c-.5.8-.4 1.8.2 2.3l.7.7c-.1.4-.1.9-.1 1.3s0 .9.1 1.3L2 12c-.6.5-.7 1.4-.2 2.2l.7 1.2c.4.8 1.3 1.1 2 .9l.9-.3c.7.6 1.5 1 2.3 1.3l.2.9c.1.8.9 1.3 1.8 1.3h1.5c1 0 1.7-.5 1.8-1.3l.2-.9c.9-.3 1.7-.7 2.4-1.3l.9.1c.7.3 1.5-.1 2-.9l.7-1.2c.5-.8.4-1.7-.2-2.2l-.7-.6zm-2-2.6c.1.4.2.9.2 1.4 0 .4-.1.9-.2 1.4l-.2.6 1.3 1.2-.7 1.1-1.7-.6-.4.4c-.8.7-1.6 1.2-2.6 1.5l-.6.2-.3 1.7H9.8l-.2-1.8-.6-.2c-1-.3-1.9-.8-2.6-1.5l-.4-.4-1.7.6-.7-1.1L4.9 12l-.2-.6c-.1-.5-.2-.9-.2-1.4s.1-1 .2-1.5l.2-.6-1.3-1.1.6-1.1 1.7.5.4-.4c.7-.7 1.6-1.2 2.6-1.5h.6l.3-1.7h1.3l.3 1.7.6.2c1 .3 1.9.8 2.6 1.5l.4.4 1.7-.6.7 1.1L16.1 8l.2.6z"/><path pid="1" class="st0" d="M10.3 6.3c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5 3.5-1.6 3.5-3.5-1.6-3.5-3.5-3.5zm0 5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/setting.js